import script from "./HeaderHome.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderHome.vue?vue&type=script&setup=true&lang=js"

import "./HeaderHome.vue?vue&type=style&index=0&id=b7840e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7840e46"]])

export default __exports__